import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, updateDoc, collection, addDoc, query, where, getDocs, increment, arrayUnion } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBTnOuGxU8wxI4n6fgsRgxwyub4YHhUtRk",
  authDomain: "toad-e5d5b.firebaseapp.com",
  projectId: "toad-e5d5b",
  storageBucket: "toad-e5d5b.firebasestorage.app",
  messagingSenderId: "1049177870423",
  appId: "1:1049177870423:web:6ac1a4f8aadaebd9eb1312",
  measurementId: "G-MC22KF34LN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// ═══ REFERRAL TIERS ═══
const REFERRAL_TIERS = [
  { min: 1, max: 5, reward: 0.50 },
  { min: 6, max: 15, reward: 0.75 },
  { min: 16, max: Infinity, reward: 1.00 },
];

export function getReferralReward(count) {
  for (const t of REFERRAL_TIERS) if (count >= t.min && count <= t.max) return t.reward;
  return 1.00;
}

// ═══ USER OPERATIONS ═══
export async function registerOrFetchUser(walletAddress) {
  const addr = walletAddress.toLowerCase();
  const ref = doc(db, "users", addr);
  const snap = await getDoc(ref);
  if (snap.exists()) return { id: snap.id, ...snap.data() };

  const refCode = "TOAD-" + Math.random().toString(36).substring(2, 8).toUpperCase();
  const newUser = {
    wallet: addr,
    refCode,
    referredBy: null,
    joinedAt: new Date().toISOString(),
    actions: { sharedX: false, joinedTG: false },
    referralCount: 0,
    rewards: [],
    totalEarned: 0,
    totalPaid: 0,
    gameScores: [],
    status: "active",
  };
  await setDoc(ref, newUser);
  return { id: addr, ...newUser };
}

export async function recordAction(walletAddress, actionType, rewardAmount) {
  const addr = walletAddress.toLowerCase();
  const reward = { type: actionType, amount: rewardAmount, timestamp: new Date().toISOString(), status: "pending" };
  await updateDoc(doc(db, "users", addr), {
    [`actions.${actionType}`]: true,
    rewards: arrayUnion(reward),
    totalEarned: increment(rewardAmount),
  });
  await addDoc(collection(db, "rewards"), { wallet: addr, type: actionType, amount: rewardAmount, timestamp: new Date().toISOString(), status: "pending" });
}

export async function processReferral(newUserAddress, refCode) {
  const addr = newUserAddress.toLowerCase();
  const q = query(collection(db, "users"), where("refCode", "==", refCode));
  const snap = await getDocs(q);
  if (snap.empty) return;
  const referrer = snap.docs[0];
  if (referrer.id === addr) return; // can't refer yourself

  await updateDoc(doc(db, "users", addr), { referredBy: refCode });

  const referrerData = referrer.data();
  const count = (referrerData.referralCount || 0) + 1;
  const rewardAmt = getReferralReward(count);
  const reward = { type: "referral", amount: rewardAmt, referredUser: addr, timestamp: new Date().toISOString(), status: "pending" };

  await updateDoc(doc(db, "users", referrer.id), {
    referralCount: increment(1),
    rewards: arrayUnion(reward),
    totalEarned: increment(rewardAmt),
  });
  await addDoc(collection(db, "rewards"), { wallet: referrer.id, type: "referral", amount: rewardAmt, referredUser: addr, timestamp: new Date().toISOString(), status: "pending" });
}

export async function recordGameScore(walletAddress, score, hash, rewardAmt) {
  const addr = walletAddress.toLowerCase();
  const entry = { type: "game", score, hash, amount: rewardAmt, timestamp: new Date().toISOString(), status: "pending" };
  await updateDoc(doc(db, "users", addr), {
    gameScores: arrayUnion({ score, hash, reward: rewardAmt, timestamp: entry.timestamp }),
    rewards: arrayUnion(entry),
    totalEarned: increment(rewardAmt),
  });
  await addDoc(collection(db, "rewards"), { wallet: addr, type: "game", amount: rewardAmt, score, hash, timestamp: entry.timestamp, status: "pending" });
}

export { REFERRAL_TIERS };

// ═══ SITE CONFIG (reads admin settings from Firebase) ═══
export async function getSiteConfig() {
  const { doc, getDoc } = await import("firebase/firestore");
  const { getFirestore } = await import("firebase/firestore");
  const db = getFirestore();
  try {
    const snap = await getDoc(doc(db, "config", "site"));
    return snap.exists() ? snap.data() : null;
  } catch (e) { console.warn("Config load failed:", e); return null; }
}
